import { useState, useEffect, useCallback } from 'react';
import { getRiskAnalysts, RiskAnalystDto } from '../services/RiskAnalystService';

export const useRiskAnalysts = (enabled: boolean) => {
  const [riskAnalysts, setRiskAnalysts] = useState<RiskAnalystDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRiskAnalysts = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getRiskAnalysts();
      if (response.success && Array.isArray(response.data)) {
        setRiskAnalysts(response.data as RiskAnalystDto[]);
      } else {
        const msg =
          typeof response.message === 'string'
            ? response.message
            : 'Error al cargar analistas de riesgo';
        setError(msg);
        setRiskAnalysts([]);
      }
    } catch {
      setError('Error al cargar analistas de riesgo');
      setRiskAnalysts([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setRiskAnalysts([]);
      return;
    }
    void fetchRiskAnalysts();
  }, [enabled, fetchRiskAnalysts]);

  return { riskAnalysts, isLoading, error, refreshRiskAnalysts: fetchRiskAnalysts };
};
